export function toFormData(payload = {}, { includeNull = false } = {}) {
  const form = new FormData()

  Object.entries(payload).forEach(([key, value]) => {
    if (value === undefined) return
    if (value === null && !includeNull) return
    form.set(key, value)
  })

  return form
}
